import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

import { salesforceMetadata } from 'app/registries/linked-service/salesforce-metadata';
import { format } from 'app/shared/utils/string.util';
import { EnvironmentInjector } from '@angular/core';
import { getConnectorV1Name, getConnectorV2Name } from 'shell-models-lib';

export const salesforceServiceCloudMetadata = async (injector: EnvironmentInjector) => {
    const result: ILinkedServiceTypeMetadata = {
        ...(await salesforceMetadata(injector)),
        type: adfModelTypeMap.salesforceServiceCloud.linkedServiceType,
        displayName: getConnectorV1Name(stringResources.SalesforceServiceCloud_DisplayText),
        copySinkTypes: [adfModelTypeMap.salesforceServiceCloud.copySinkType],
        copySourceTypes: [adfModelTypeMap.salesforceServiceCloud.copySourceType],
        warningMessage: format(
            stringResources.Connector_Legacy_IsNotSupportedWarning_alt2,
            stringResources.LinkedServiceLowerCase,
            getConnectorV2Name(stringResources.SalesforceServiceCloud_DisplayText)
        ),
        warningMessageHyperlink:
            'https://learn.microsoft.com/azure/data-factory/connector-salesforce-service-cloud?tabs=data-factory',
    };
    return result;
};
